import axios from 'axios'
import type { AxiosError } from 'axios'

// Wrapper around axios.isAxiosError, so in case we change underlying library for ysc-api-js we just have to change this function to detect api error
export type RawApiError = AxiosError
export const isRawApiError = (error: Error): error is RawApiError => axios.isAxiosError(error)
